import { hash01 } from './hash';

const smooth = (t: number): number => t * t * (3 - 2 * t);

/** Deterministic 1D value noise in [0, 1): hashed lattice values, smoothstep-interpolated. */
export function valueNoise1D(seed: number, key: string, x: number): number {
  const i = Math.floor(x);
  const f = x - i;
  const a = hash01(seed, key, i);
  const b = hash01(seed, key, i + 1);
  return a + (b - a) * smooth(f);
}

/** Fractal sum of value noise, normalised to [0, 1). */
export function fbm1D(seed: number, key: string, x: number, octaves = 4, gain = 0.5, lacunarity = 2): number {
  let sum = 0;
  let amp = 1;
  let norm = 0;
  let freq = 1;
  for (let o = 0; o < octaves; o++) {
    sum += amp * valueNoise1D(seed, `${key}#${o}`, x * freq);
    norm += amp;
    amp *= gain;
    freq *= lacunarity;
  }
  return sum / norm;
}
